import { atom, useAtom } from "jotai";
import React, { useEffect, useState } from "react";
import { DynamicField } from "../../../Common/models/form";
import { mapCreateProjectFormField } from "../../../Common/utils/dynamicFieldUtil";
import { getPackages } from "../api/packagesHttpClient";
import { Package } from "../models/Package";
import { ProjectFormType } from "../../../Common/hooks/useCreateProject";
import { selectedToolsAtom } from "../../../Common/hooks/useToolsForSelect";
import { PackageGrouped } from "../models/PackageCategory";
import _ from "lodash";

export const selectedPackageAtom = atom<{
  id: string;
  name: string;
  fields?: DynamicField<ProjectFormType>[];
}>({ id: "", name: "" });

const useSelectPackage = (setActiveStep: (step: number) => void) => {
  const [__, setSelectedPackage] = useAtom(selectedPackageAtom);
  const [___, setSelectedTools] = useAtom(selectedToolsAtom);

  const [packagesGrouped, setPackagesGrouped] = useState<PackageGrouped[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState<React.ReactNode>();
  const [popupTitle, setPopupTitle] = useState("");

  useEffect(() => {
    setIsLoading(true);
    getPackages()
      .then((packages) => {
        const groupedPackages = _.chain(packages)
          .sortBy((p) => p.packageCategory.sequenceNumber)
          .groupBy(({ packageCategory }) => packageCategory.id)
          .map((ps, id) => ({
            packageCategory: ps[0].packageCategory,
            packages: ps,
          }))
          .value();
        setPackagesGrouped(groupedPackages);
        setSelectedTools([]);
      })
      .finally(() => setIsLoading(false));
  }, []);
  const onMoreInfoClickHandler = (selectedPackage: Package) => {
    setIsPopupOpen(true);
    if (selectedPackage.moreInfo) {
      // Create a div element with HTML content
      const htmlContent = React.createElement("div", {
        dangerouslySetInnerHTML: { __html: selectedPackage.moreInfo },
      });
      setPopupContent(htmlContent);
    } else {
      setPopupContent(`${selectedPackage.name} additional info`);
    }
    setPopupTitle(`About the ${selectedPackage.name} package`);
  };

  const closePopupHandler = () => setIsPopupOpen(false);

  const selectPackageHandler = (selectedPackage: Package) => {
    setSelectedPackage({
      ...selectedPackage,
      fields: selectedPackage.CustomFields?.map((field) =>
        mapCreateProjectFormField(field)
      ),
    });
    if (selectedPackage.optionalTools?.length > 0) {
      setActiveStep(1);
    } else {
      setActiveStep(1);
      setTimeout(() => {
        setActiveStep(2);
      });
    }
  };

  return {
    packagesGrouped,
    isLoading,
    onMoreInfoClickHandler,
    isPopupOpen,
    closePopupHandler,
    popupContent,
    selectPackageHandler,
    popupTitle,
  };
};

export default useSelectPackage;
